import { API_BASE_URL } from '../constants';


//goals
export const GET_GOALS = `${API_BASE_URL}/goals`;
export const CREATE_GOAL = `${API_BASE_URL}/goals/create`;
export const ADD_GOAL_CONTRIBUTION = `${API_BASE_URL}/goals/contribute`;
export const TOGGLE_DAILIES = `${API_BASE_URL}/goals/daily`;
export const GET_DASHBOARDS = `${API_BASE_URL}/dashboards`;
export const EDIT_DASHBOARD = `${API_BASE_URL}/dashboards/edit`;
export const USERNAME_CHECK = `${API_BASE_URL}/users/check-username`;
export const USERNAME_SIGNUP = `${API_BASE_URL}/users/signup`;
export const GET_DASHBOARD_HOMEPAGE = `${API_BASE_URL}/dashboards/homepage`;
export const GET_HOMEPAGE_VERSION = `${API_BASE_URL}/dashboards/version`;
export const GET_USER_DASHBOARDS = `${API_BASE_URL}/dashboards/username`;
export const GET_MY_USER_DATA = `${API_BASE_URL}/users/getMyUserData`;
export const SEND_PUBLIC_MESSAGE = `${API_BASE_URL}/dashboards/send-public-message`;
export const GET_WANIKANI = `${API_BASE_URL}/dashboards/wanikani`;
export const GET_NARUHONE_DATA = `${API_BASE_URL}/dashboards/naruhone`;
export const GET_PUBLIC_MESSAGE = `${API_BASE_URL}/dashboards/get-public-message`;